import { useEffect, useState } from "react";
import useLogout from "../../hooks/useLogout";

const AutoLogOut = () => {
  const handleLogout = useLogout();
  const [signoutTime] = useState(900000);
  let logoutTimeout;

  const setTimeouts = () => {
    logoutTimeout = setTimeout(handleLogout, signoutTime);
  };

  const clearTimeouts = () => {
    if (logoutTimeout) clearTimeout(logoutTimeout);
  };

  useEffect(() => {
    const events = [
      "load",
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress", "touchstart"
    ];

    const resetTimeout = () => {
      clearTimeouts();
      setTimeouts();
    };

    for (let i in events) {
      window.addEventListener(events[i], resetTimeout);
    }

    setTimeouts();
    return () => {
      for (let i in events) {
        window.removeEventListener(events[i], resetTimeout);
        clearTimeouts();
      }
    };
  }, []);

  return null;
};

export default AutoLogOut;
